// api/temporal_students.js
// 一時的な生徒に対するAPIを実装する

import Api from './api_base'

export default {
  // GET /temporal_students/{fullname}  指定された氏名の一時的な生徒のユーザIDを取得する
  getByFullname: (fullname) => {
    return Api.get('/temporal_students/' + fullname)
  }
}



// WEBPACK FOOTER //
// ./src/api/temporal_students.js